import { journeyElementsStore } from '../JourneyElementsStore';

export const useStopById = (id: string) => {
	const stops = journeyElementsStore(x => x.stops);
	return stops.find(x => x.id === id);
};
